import MapGenericBaidu from '$Feature/GenericComponents/code/src/mapGeneric/implementations/mapGenericBaidu';

export default class FilterMapBaidu extends MapGenericBaidu {
    initMap() {}
}
